import { useEffect } from 'react';

import { MailSubscriptionModal } from '@/widgets/MailSubscriptionModal';

import { useAppDispatch, useAppSelector } from '@/shared/hooks/appRedux';
import { ModalService } from '@/shared/services/modal';

import { EVENT_OPEN_MODAL, getSettings, setShowWidgetModal } from '.';

export const useManagedMailSubscriptionModal = (): void => {
  const settings = useAppSelector(getSettings);
  const dispatch = useAppDispatch<MailSubscriptionAppDispatch>();

  const handleCloseOnRequest = (): void => {
    dispatch(setShowWidgetModal(false));
  };
  useEffect(() => {
    if (settings?.isShowWidget) {
      setTimeout(() => {
        ModalService.open(
          MailSubscriptionModal,
          {
            onRequestClose: handleCloseOnRequest,
            shouldReturnFocusAfterClose: false,
          },
          EVENT_OPEN_MODAL,
        );
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings?.isShowWidget]);
};
